module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Deleted-folder-af68c71710ed69e8d1682bc2e733ee2d.svg";